<template>
  <div>
    <br />
    <el-form
      ref="dataForm"
      :inline="true"
      :model="dataForm"
      @submit.native.prevent
      @keyup.enter.native="getDataList()"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item prop="name">
            <el-input
              v-model="dataForm.name"
              placeholder="用户名或姓名"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="
                pageIndex = 1
                getDataList(true)
              "
              >查询</el-button
            >
            <el-button @click="refreshForm()">重置</el-button>
            <el-button type="danger" @click="addPerson()">新增</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table :data="dataList" v-loading="tabLoding" border style="width: 100%">
      <el-table-column
        prop="loginName"
        header-align="center"
        align="center"
        label="用户名"
      >
      </el-table-column>
      <el-table-column
        prop="userName"
        header-align="center"
        align="center"
        label="姓名"
      >
      </el-table-column>
      <el-table-column
        prop="deptName"
        header-align="center"
        align="center"
        label="所属组织"
      >
      </el-table-column>
      <el-table-column
        prop="remark"
        header-align="center"
        align="center"
        label="备注"
      >
        <template slot-scope="scope">
          {{ scope.row.remark || '-' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="setup"
        header-align="center"
        align="center"
        width="200px"
        label="停用/启用"
      >
        <template slot-scope="scope">
          <el-switch
            class="switchStyle"
            v-model="scope.row.setup"
            :disabled="scope.row.perm === 'admin'"
            @change="setupChange(scope.row)"
            active-text="启用"
            inactive-text="停用"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="150"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editHandle(scope.row)"
            >修改</el-button
          >
          <el-button
            v-if="scope.row.perm !== 'admin'"
            type="text"
            size="small"
            @click="deleteHandle(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div v-if="totalPage > 0">
      <el-pagination
        class="mt-sm"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
    <add-user
      v-if="addVisible"
      ref="addModal"
      @refreshDataList="getDataList"
    ></add-user>
  </div>
</template>

<script>
import AddUser from './AddUser.vue'
export default {
  data() {
    return {
      dataForm: {
        name: ''
      },
      tabLoding: false,
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      addVisible: false
    }
  },
  components: {
    AddUser
  },

  mounted() {
    this.pageIndex = 1
    this.getDataList()
  },
  methods: {
    // 获取用户列表
    getDataList() {
      this.tabLoding = true
      this.$http({
        url: this.$http.adornUrl('/api/adminManage/allUsersInformation'),
        method: 'get',
        params: this.$http.adornParams({
          currentPage: this.pageIndex,
          size: this.pageSize,
          name: this.dataForm.name.trim(),
          hasAdmin: 1
        })
      })
        .then((res) => {
          const data = res.data
          if (data && res.resp_code === 0) {
            if (data.list.length === 0 && data.total > 0) {
              this.pageIndex = this.pageIndex - 1
              this.getDataList()
            } else {
              this.dataList = data.list
              this.dataList.forEach((item) => {
                item.setup = false
                if (item.status === '0') {
                  item.setup = true
                }
              })
              this.dataList = JSON.parse(JSON.stringify(this.dataList))
              this.totalPage = data.total
            }
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.tabLoding = false
        })
        .catch(() => {
          this.dataList = []
          this.totalPage = 0
          this.tabLoding = false
        })
    },
    // 重置
    refreshForm() {
      this.$refs.dataForm.resetFields()
      this.pageIndex = 1
      this.getDataList()
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 启用停用
    setupChange(info) {
      this.$http({
        url: this.$http.adornUrl('/api/adminManage/controlUser'),
        method: 'post',
        params: this.$http.adornParams({
          uid: info.id,
          controlNum: info.setup ? 0 : 1 // 参数0为启用，1为停用
        })
      }).then((res) => {
        if (res.resp_code === 0) {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500
          })
        } else {
          this.$message.error(res.resp_msg || '操作失败')
        }
      })
    },
    // 修改用户
    editHandle(info) {
      this.addVisible = true
      this.$nextTick(() => {
        this.$refs.addModal.init(info)
      })
    },
    // 新增用户
    addPerson() {
      this.addVisible = true
      this.$nextTick(() => {
        this.$refs.addModal.init('')
      })
    },
    // 删除
    deleteHandle(id) {
      const that = this
      this.$confirm('若该用户下有维护的产品,则无法删除。', '确定删除吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          that.deleteSure(id)
        })
        .catch(() => {})
    },
    deleteSure(id) {
      this.$http({
        url: this.$http.adornUrl('/api/edit/delUser'),
        method: 'post',
        params: this.$http.adornParams({
          uid: id
        })
      }).then((res) => {
        if (res.resp_code === 0) {
          this.getDataList()
          this.$message({
            message: '删除成功',
            type: 'success',
            duration: 1500
          })
        } else {
          this.$message.error(res.resp_msg || '操作失败')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .switchStyle .el-switch__label {
    position: absolute;
    display: none;
    color: #fff;
  }
  .switchStyle .el-switch__label--left {
    z-index: 9;
    left: 6px;
  }
  .switchStyle .el-switch__label--right {
    z-index: 9;
    left: -14px;
  }
  .switchStyle .el-switch__label.is-active {
    display: block;
  }
  .switchStyle.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 50px !important;
  }
  .el-switch__label * {
    font-size: 12px;
  }
}
</style>
